import { render, staticRenderFns } from "./PrintPageBreakControl.vue?vue&type=template&id=9bed0958&scoped=true"
import script from "./PrintPageBreakControl.vue?vue&type=script&lang=js"
export * from "./PrintPageBreakControl.vue?vue&type=script&lang=js"
import style0 from "./PrintPageBreakControl.vue?vue&type=style&index=0&id=9bed0958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bed0958",
  null
  
)

export default component.exports